import { Icon } from '@zillow/constellation-10';
import { IconChevronLeftFilled, IconChevronRightFilled } from '@zillow/constellation-icons';
import { FacebookAdPreview } from './FacebookAdPreview';
// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
import { styled } from '@/styled-system/jsx';
import { useEffect, useRef, useState } from 'react';

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const CarouselWrapper = styled('div', {
  base: {
    position: 'relative',
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const FacebookAdPreviewCarouselContainer = styled('div', {
  base: {
    display: 'flex',
    overflowX: 'auto',
    '& .facebook-preview': {
      marginRight: '8px',
    },
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const ArrowButton = styled('button', {
  base: {
    width: '48px',
    height: '48px',
    backgroundColor: 'white',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    boxShadow: 'none',
    border: '1px solid',
    borderColor: 'gray.300',
    borderRadius: '50%',
    cursor: 'pointer',
    '& svg': {
      position: 'relative',
      top: '2px',
    },
  },
  variants: {
    position: {
      left: {
        left: '12px',
      },
      right: {
        right: '12px',
      },
    },
  },
});

export const FacebookAdPreviewCarousel = ({
  previewImages,
  address,
  title,
}: {
  previewImages: Array<string>;
  address: string;
  title: string;
}) => {
  const [scrollOffset, setScrollOffset] = useState<number>(0);
  const [hasScrollbar, setHasScrollbar] = useState<boolean>(true);
  const [maxOffset, setMaxOffset] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const scrollRight = (right: boolean) => {
    if (!containerRef?.current) return;

    const offsetMult = right ? 1 : -1;

    containerRef.current.scrollBy({
      left: offsetMult * 300,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const scrollableDiv = containerRef.current;
    if (!scrollableDiv) return;

    const handleScrollEnd = () => {
      setScrollOffset(scrollableDiv.scrollLeft);
      setMaxOffset(scrollableDiv.scrollWidth - (scrollableDiv.offsetWidth ?? 0));
      setHasScrollbar(scrollableDiv.scrollWidth > scrollableDiv.clientWidth);
    };

    scrollableDiv.addEventListener('scrollend', handleScrollEnd);

    handleScrollEnd();
    return () => {
      if (scrollableDiv) {
        scrollableDiv.removeEventListener('scrollend', handleScrollEnd);
      }
    };
  }, [setScrollOffset]);

  return (
    <CarouselWrapper>
      <FacebookAdPreviewCarouselContainer ref={containerRef}>
        {previewImages.map((imageUrl) => (
          <FacebookAdPreview key={imageUrl} imageUrl={imageUrl} address={address} title={title} />
        ))}
        {scrollOffset < maxOffset && hasScrollbar && (
          <ArrowButton position="right" onClick={() => scrollRight(true)}>
            <Icon>
              <IconChevronRightFilled />
            </Icon>
          </ArrowButton>
        )}
        {scrollOffset > 0 && hasScrollbar && (
          <ArrowButton position="left" onClick={() => scrollRight(false)}>
            <Icon>
              <IconChevronLeftFilled />
            </Icon>
          </ArrowButton>
        )}
      </FacebookAdPreviewCarouselContainer>
    </CarouselWrapper>
  );
};
